/**
 * Stone Veins
 *
 * 10 static crack/vein lines rendered as thin divs.
 * The faintest gold trace — purely structural texture, no animation.
 * CSS handles positioning in challenge.css.
 */

import React from 'react';

const VEIN_COUNT = 10;

export const StoneVeins: React.FC = () => {
  return (
    <div className="stone-veins-layer">
      {Array.from({ length: VEIN_COUNT }, (_, i) => (
        <div key={i} className="stone-vein" />
      ))}
    </div>
  );
};
